module.exports = {
    RULE_BEFORE_VALIDATION: 'beforeValidation',
    RULE_AFTER_VALIDATION: 'afterValidation',
    RULE_BEFORE_CREATE: 'beforeCreate',
    RULE_BEFORE_UPDATE: 'beforeUpdate',
    RULE_BEFORE_FIND: 'beforeFind',
    RULE_BEFORE_DELETE: 'beforeDelete',
    RULE_AFTER_CREATE: 'afterCreate',
    RULE_AFTER_UPDATE: 'afterUpdate',
    RULE_AFTER_DELETE: 'afterDelete',
};
